
document.addEventListener(
  "change",
  function (event) {
    const input = event.target;

    if (
      !(input instanceof HTMLInputElement) ||
      input.type !== "checkbox" ||
      input.name !== "filter.p.m.custom.shop_by_moments" ||
      !input.checked
    ) {
      return;
    }

    const facetsForm = input.closest("facets-form");
    if (!facetsForm) return;

    const accordion = input.closest("accordion-disclosure");
    if (!accordion) return;

    const title = accordion.querySelector("summary");
    if (!title || title.textContent.trim().toLowerCase() !== "occasion") {
      return;
    }

    accordion
      .querySelectorAll(
        'input[type="checkbox"][name="filter.p.m.custom.shop_by_moments"]'
      )
      .forEach(function (otherInput) {
        if (otherInput !== input && otherInput.checked) {
          otherInput.checked = false;
        }
      });
  },
  true
);
